<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container pt-4">
    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      [class.bold]="alert.bold"
      style="top: 10px"
      ><span [innerHTML]="alert.message"></span
    ></ngb-alert>

    <div class="row pb-4 d-flex justify-content-center">
      <div class="col-md-10 mb-3">
        <app-tok-header
          [title]="
            'The breeder of your pet has started the transfer of keepership to you.<br/><br/>You will need to complete and verify your details before we can complete the transfer. You will then be able to make the payment of ' + tokFee + ' and complete the transfer, which includes the first year of our identialert service.'
          "
          [subTitle]="
            'Log in to your account below to proceed.'
          "
        ></app-tok-header>
      </div>
      <div class="col-md-5 mb-3">
        <form #loginForm="ngForm" (ngSubmit)="login()" novalidate>
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div class="mb-1">
              <div>
                <label class="form-label mb-0" for="email">Your email address</label>
              </div>
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <img src="/assets/images/home/email_icon.svg" alt="search-icon" class="password-icon" />
                  <input
                    [class.is-invalid]="email.touched && !email.valid"
                    id="email"
                    name="email"
                    class="text-input-with-icon"
                    [(ngModel)]="model.identifier"
                    [placeholder]="'Enter email'"
                    (ngModelChange)="closeAlert()"
                    matInput
                    #email="ngModel"
                    required
                  />
                  <!--This next div is needed to make the input high enough-->
                  <div class="dummy-div" matSuffix></div>
                  <mat-error
                    *ngIf="(email.errors && email.errors.required)"
                  >
                    {{ errorStrings.required }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="mb-1">
              <div>
                <label class="form-label mb-0" for="password"> Password </label>
              </div>
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <img src="/assets/images/home/password_icon.svg" alt="search-icon" class="password-icon" />
                  <input
                    matInput
                    #password="ngModel"
                    [type]="hidePassword ? 'password' : 'text'"
                    id="password"
                    class="text-input-with-icon"
                    (ngModelChange)="closeAlert()"
                    name="password"
                    [(ngModel)]="model.password"
                    placeholder="Password"
                    required
                  />
                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hidePassword"
                  >
                    <mat-icon>{{
                      hidePassword ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          
            <div class="mb-3 text-end">
              <a
                routerLink="/forgot-password"
                [queryParams]="{ email: email.valid ? model.identifier : null }"
                >Forgot password?</a
              >
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-success text-white btn-lg w-100 mt-5"
            [disabled]="!loginForm.valid || loading || redirectTimer"
          >
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-3"
            ></fa-icon>
            {{ loading ? "Signing in..." : "Log in" }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
